module.exports = __webpack_public_path__ + "img/chat-send.0bbd7424.svg";